import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { CustomerModel } from "@models/customer/customerModel"

interface ParamCategory {
  id?: any
  value?: any
}

class FilterService {
  // API for admin config filter

  public async getListColumnByModuleForAdmin(module): Promise<any> {
    if (!module) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get(
      "api/services/app/CustomFilter/GetListColumnsByModule",
      {
        params: { module },
      }
    )
    const { result } = res.data
    return CustomerModel.assign(result)
  }
  public async getColumnById(id): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/CustomFilter/GetColumById", {
      params: { id },
    })
    const { result } = res.data
    return CustomerModel.assign(result)
  }
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/CustomFilter/CreateOrUpdateColumns",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async delete(id: number) {
    const result = await http.delete("api/services/app/CustomFilter/Delete", {
      params: { id },
    })
    return result.data
  }

  // GET OPTION OF COLUMN TYPE DROPDOWN
  public async getListCategoriesByColumnId(params: ParamCategory) {
    const res = await http.get(
      "api/services/app/Category/GetListCategoriesByColumnId",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }

  // API for module

  public async getListColumnByModuleForClient(module): Promise<any> {
    if (!module) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get(
      "api/services/app/CustomFilter/GetListColumnsByModuleForClient",
      {
        params: { module },
      }
    )
    const { result } = res.data
    return result
  }
  public async getListFilter(module): Promise<any> {
    if (!module) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get(
      "api/services/app/CustomFilter/GetMyFiltersByModule",
      {
        params: { module },
      }
    )
    const { result } = res.data
    return result
  }
  public async getFilter(id): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get(
      "api/services/app/CustomFilter/GetMyFilterById",
      {
        params: { id },
      }
    )
    const { result } = res.data
    return result
  }
  public async createOrUpdateFilter(body: any) {
    const res = await http.post(
      "api/services/app/CustomFilter/CreateOrUpdateMyFilter",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async deleteMine(id: number) {
    const result = await http.delete(
      "api/services/app/CustomFilter/DeleteMine",
      {
        params: { id },
      }
    )
    return result.data
  }
}

export default new FilterService()
